import { render, staticRenderFns } from "./EndMoratoriumModal.vue?vue&type=template&id=372ae6d3&"
import script from "./EndMoratoriumModal.vue?vue&type=script&lang=js&"
export * from "./EndMoratoriumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports